import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OrdinalPipe } from './ordinal.pipe';

@NgModule({
  declarations: [OrdinalPipe],
  imports: [CommonModule],
  exports: [OrdinalPipe],
  providers: [OrdinalPipe],
})
export class ApplicationPipesModule {}
